<template lang="html">

  <article class="oferta row-start aifs">

    <div class="contenedor-textos">

      <h3 class="empresa -backgroundLoad"></h3>

      <h2 class="title-dato -backgroundLoad"></h2>

      <p class="status -backgroundLoad"></p>
    
      <div class="info column-center">
        <p class="-fecha -backgroundLoad"></p>
        <p class="-lugar -backgroundLoad"></p>
      </div>

    </div>

  </article>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'oferta-el--fake',
    computed : {
      ...mapGetters({
        style : 'getStyles',
        colors : 'basicColors'
      }),      
    }
  }
</script>

<style scoped lang="scss">

@import '@/assets/css/colors.scss';

.oferta{
  width: 100%;
  padding: 20px 0;
  flex-wrap: nowrap;
  -ms-align-items: flex-start;
  align-items: flex-start;
  position: relative;
}

.title-dato{
  font-size: 20px;
  margin-bottom: 0;
  max-width: 200px;
  height: 25px;
}

.empresa{
  height: 17px;
  max-width: 140px;
  width: 100%;
  display: inline-block;
}

.oferta:last-of-type{
  padding-bottom: 0;
}

.contenedor-textos{
  padding-right: 150px;
  position: relative;
}


.info{
  width: 150px;
  padding-left: 20px;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
}

.info p{
  margin-bottom: 5px;
  height: 20px;
  max-width: 100px;
  width: 100%;
  display: inline-block;
}

.status{
  margin-top: 10px;
  margin-bottom: 0;
  max-width: 160px;
  height: 20px;
  display: inline-block;
  width: 100%;
}





</style>



// WEBPACK FOOTER //
// src/components/views/home/oferta-el--fake.vue